import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { identity, is } from 'ramda';

class FormProvider extends Component {
  getChildContext() {
    const {
      editing,
      formValues,
      localeIdFormatter,
      condensedView = true,
      intl: { formatMessage },
    } = this.props;
    const idFormatter = is(Function, localeIdFormatter) ? localeIdFormatter : identity;

    const localeMessage = id =>
      id && is(String, id)
        ? formatMessage({ id: idFormatter(id) })
        : ' >>> Locale ID is missing or is not a string <<<';

    return { editing: window.__ROLE__ !== 'DOCTOR' ? editing : false, formValues, condensedView, localeMessage };
  }

  render() {
    const { children } = this.props;
    return createElement('div', {}, children);
  }
}

FormProvider.propTypes = {
  editing: PropTypes.bool,
  formValues: PropTypes.object,
  localeIdFormatter: PropTypes.func,
  children: PropTypes.node,
  condensedView: PropTypes.bool,
  intl: intlShape,
};

FormProvider.childContextTypes = {
  editing: PropTypes.bool,
  formValues: PropTypes.object,
  localeMessage: PropTypes.func,
  condensedView: PropTypes.bool,
};

export default injectIntl(FormProvider);
